import { Pipe, PipeTransform } from "@angular/core";
import { Models } from "@ibexfusion/models";
import { ContentService } from "../../services/content/content.service";

@Pipe({
  name: 'contentPublicTransport'
})

export class PublicTransportPipe implements PipeTransform {

  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.PublicTransportEntry[] {
    let publicTransports: any = [];
    for (let i = 0; i < entry.related.entries.length; i++) {
      const relatedEntry = this.contentService.getEntry(entry.related.entries[i].id);
      if (!relatedEntry) {
        continue;
      }
      const publicTransportEntry = new Models.PublicTransportEntry();
      publicTransportEntry.title = relatedEntry.title;
      publicTransportEntry.sourceId = relatedEntry._id;
      publicTransportEntry.media = this.contentService.getMediaEntriesForEntry(relatedEntry._id);
      publicTransportEntry.stopId = relatedEntry.detail.stopId;
      publicTransportEntry.stopIcon = relatedEntry.detail.stopIcon;
      publicTransportEntry.additionalStops = relatedEntry.detail.additionalStops;
      publicTransports.push(publicTransportEntry);
    }
    return publicTransports;
  }
}
